import styled from 'styled-components';

const ContainerStyled = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export default ContainerStyled;
